// extracted by mini-css-extract-plugin
module.exports = {"c1rvlapt":"c1rvlapt","c9upyed":"c9upyed","c1qpdiem":"c1qpdiem","footer":"footer","no3p49c":"no3p49c","tek10ch":"tek10ch","t1nd5nxc":"t1nd5nxc","tutx4n6":"tutx4n6"};